import React from 'react';
import styles from './PartnersItem.module.scss';
import classNames from 'classnames';

const PartnersItem = ({ item, onClick, isActive }) => {
  return (
    <li className={classNames(!isActive ? [styles.item] : [styles.activeItem, styles.item])}>
      <button
        onClick={() => {
          onClick(item.id);
        }}>
        <img src={item.logo} alt="" />
      </button>
    </li>
  );
};

export default PartnersItem;
